import { render, staticRenderFns } from "./ActivityDayLeaderboardList.vue?vue&type=template&id=7453f10a&scoped=true&lang=pug&"
import script from "./ActivityDayLeaderboardList.vue?vue&type=script&lang=ts&"
export * from "./ActivityDayLeaderboardList.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityDayLeaderboardList.vue?vue&type=style&index=0&id=7453f10a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7453f10a",
  null
  
)

export default component.exports